import { INpsState } from '../types/nps';
import {
  NPS_OPEN_MODAL,
  NPS_SELECT_SCORE,
  NPS_RECORD_SHOWN_SUCCESS,
  NPS_RECORD_SHOWN_FAILURE,
  NPS_SUBMIT_REQUEST,
  NPS_SUBMIT_SUCCESS,
  NPS_SUBMIT_FAILURE,
} from '../actions/npsActions';

const initialState: INpsState = {
  isModalOpen: false,
  selectedScore: null,
  npsResponseId: null,
  isSubmitting: false,
  error: null,
};

const npsReducer = (state: INpsState = initialState, action: any): INpsState => {
  switch (action.type) {
    case NPS_OPEN_MODAL:
      return {
        ...state,
        isModalOpen: true,
        selectedScore: null,
        npsResponseId: null,
        error: null,
      };

    case NPS_SELECT_SCORE:
      return { ...state, selectedScore: action.payload };

    case NPS_RECORD_SHOWN_SUCCESS:
      return { ...state, npsResponseId: action.payload };

    case NPS_RECORD_SHOWN_FAILURE:
      return { ...state, isModalOpen: false };

    case NPS_SUBMIT_REQUEST:
      return { ...state, isSubmitting: true, error: null };

    case NPS_SUBMIT_SUCCESS:
      return { ...initialState };

    case NPS_SUBMIT_FAILURE:
      return { ...state, isSubmitting: false, error: action.payload };

    default:
      return state;
  }
};

export default npsReducer;
